// extracted by mini-css-extract-plugin
export default {"target":"Target_target__CfxWI","icon":"Target_icon__sXP7l","desc":"Target_desc__5Ndth","value":"Target_value__rllHN","category":"Target_category__ZJMuR"};